module.exports = __webpack_public_path__ + "img/card-icon.7988e343.svg";